import React from 'react';
import Seo from './seo';

const Social = () => {

    return (
        <div className="social">
            <Seo
                title="Redes Sociais"
                description="Links para as redes sociais de Cesar Castro: GitHub, LinkedIn e Dev.to."
                path="/social"
            />
            <h1 className="visually-hidden">Redes Sociais</h1>
            <div className="terminal-prompt" style={{ width: '100%' }}>
                <span className="terminal-prompt-line">
                    <span className="prompt-user">user</span>
                    <span className="prompt-at">@</span>
                    <span className="prompt-host">cesarcastro</span>
                    <span className="prompt-sep">:</span>
                    <span className="prompt-path">~/social</span>
                    <span className="prompt-dollar">$</span>
                    <span className="prompt-cmd">ls -la ./networks/</span>
                    <span className="cursor"></span>
                </span>
            </div>
            <div className="social-content">
                <div className="social">
                    <a href="//github.com/crqcastro" target="_blank" rel="noopener noreferrer">
                        <img src="/images/github.svg" alt="GitHub" />
                        <span>/crqcastro</span>
                    </a>
                </div>
                <div className="social">
                    <a href="//linkedin.com/in/cesarrqcastro" target="_blank" rel="noopener noreferrer">
                        <img src="/images/linkedin.svg" alt="LinkedIn" />
                        <span>/cesarrqcastro</span>
                    </a>
                </div>
                <div className="social">
                    <a href="//dev.to/crqcastro" target="_blank" rel="noopener noreferrer">
                        <img src="/images/dev.svg" alt="Dev.to" />
                        <span>/cesarrqcastro</span>
                    </a>
                </div>
            </div>
        </div>
    )

}

export default Social;
